import React from 'react'
import "../../assets/styles/index.css"

const Label = ({ label = "", className = "", required = false, disabled = false, tooltipData = null }) => {
    return (
        <>
        {label ? 
            <label 
                for="message" 
                className={`sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-flex ${className} ${disabled ? "sd-opacity-50" : ""}`}
            >
                {label}
                <span className={`sd-text-red-500 sd-text-base sd-pl-1 ${required ? "sd-visible" : "sd-invisible" }`}>*</span>
                {tooltipData?.length > 0 ? <span class="sd-text-xs sd-ml-1 sd-mb-1.5" title={tooltipData}>
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-xs text-gray-600 hover:text-blue" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path d="M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                    </svg>
                </span> : null}
            </label>
        : 
            null
        }
        </>
    )
}

export default Label